module.exports = __webpack_public_path__ + "img/hr-tileable-beam-END.d3f55da7.png";